import { render, staticRenderFns } from "./PP.vue?vue&type=template&id=176fbf57&scoped=true"
import script from "./PP.vue?vue&type=script&lang=js"
export * from "./PP.vue?vue&type=script&lang=js"
import style0 from "./PP.vue?vue&type=style&index=0&id=176fbf57&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176fbf57",
  null
  
)

export default component.exports